import React from 'react';
import NumberFormat from 'react-number-format';
import { v4 as uuidv4 } from 'uuid';

const customFormatComponent = props => {
  const { onChange, inputRef, name, ...rest } = props;

  const additionalProps = {
    cardNumber: { format: '#### #### #### ####' },
    cardExpiry: { format: '##/##', mask: ['M', 'M', 'Y', 'Y'], spellCheck: false },
    cardCvc: { format: '#####' },
  };

  return (
    <NumberFormat
      {...rest}
      id={uuidv4()}
      getInputRef={inputRef}
      name={name}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      prefix=""
      suffix=""
      {...additionalProps[name]}
    />
  );
};

export default customFormatComponent;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/CreditCardModal/components/CustomNumberInput/CustomNumberInput.js